// extracted by extract-css-chunks-webpack-plugin
module.exports = {"activity_list":"GroupActivityList__activity_list--3nLdj","group_activity_list":"GroupActivityList__group_activity_list--1Gy1c"};